module.exports = __webpack_public_path__ + "img/anxious1.3904fe90.png";